import { render, staticRenderFns } from "./EzUserSettingsModal.vue?vue&type=template&id=d2865890&scoped=true&"
import script from "./EzUserSettingsModal.vue?vue&type=script&lang=js&"
export * from "./EzUserSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./EzUserSettingsModal.vue?vue&type=style&index=0&id=d2865890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2865890",
  null
  
)

export default component.exports